/**
 * Client-only plugin to restore auth state on page load
 */
export default defineNuxtPlugin(async (nuxtApp) => {
  const authStore = useAuthStore();

  // Try to restore auth from localStorage on app initialization
  if (process.client) {
    console.log("🔐 Checking auth state on page load...");
    const isAuthenticated = await authStore.checkAuth();

    if (isAuthenticated) {
      console.log("✅ Auth restored successfully", authStore.user);
    } else {
      console.log("ℹ️ No valid auth token found");
    }
  }
});
